import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { routes } from "../../../redux/api/routes";
const { localStorageVar, redirectURLCNetVar, bootAPIUrl, users } = routes;

/* Actions */
import {
  ajaxRequestCompleted,
  ajaxRequestInitiated,
  checkCredentials,
  deleteAuthDetails,
  getAccountDetails,
  getAddressList,
  getApprovedAccounts,
  getAssets,
  getAuthDetails,
  getLocalUserDetails,
  getNonGEASSOUserAccounts,
  getProductLineNarrorYourResultFilters,
  getPunchOutData,
  getRegistrationHelpDoc,
  getSearchKeywordSuggestionList,
  getShippingAddresses,
  getUserDetails,
  populateLatestHomePageAssets,
  postPunchOutData,
  resetHomePageObjectInStore,
  resetProductAvailabilityResultList,
  resetProductNumberKeywordResultList,
  resetSearchKeywordSuggestionList,
  resetUserDetails,
  saveAccountDetail,
  saveAccountNumber,
  saveAccountNumberDetails,
  saveAccountNumberPostLogin,
  saveApprovedAccountDetails,
  saveInvalidAttempt,
  savePostLoginSearchKeyword,
  saveProductLine,
  saveProductLineFilters,
  saveProductLineNarrowYourResultsFilters,
  saveSearchKeywordSuggestionList,
  saveSelectedAccountAndPriceSource,
  saveShippingAddresses,
  saveSSORegistrationDetails,
  saveUserDetails,
  saveUserOtherDetails,
  saveZipCode,
  saveZipCodeDetail,
  showAccountDetailProgress,
  showHideAutoSelect,
  showZipCodeLoading,
  updateHomePageAssetsFromBackup,
  updateInvalidAttempt,
} from "../../../redux/actions";

import { manipulateClipBoardToKeepNumericsOnly } from "../../../redux/util";

/* API helper & UI */
import { sendRequest } from "../../../redux/api/sendRequest";
import GenericOverlayDialog from "../../dialogs/genericOverlayDialog";
import PreLoginSearchResult from "../SearchResult";

function AvailabilityCheck(props) {
  const [productLineList] = useState(() => {
		const items = [];
		const loadProductLines = productLines => {
			productLines.forEach(productLine => {
				if (productLine.categoryId) {
					items.push(productLine);
				}
				if (productLine.subCategory && productLine.subCategory.length) {
					loadProductLines(productLine.subCategory);
				}
			})
		}

		loadProductLines(props.state.product.productLineList);
		return items;
  });
  const [showAccountNotSetupProperlyOverlayDialog, setShowAccountNotSetupProperlyOverlayDialog] = useState(false);
  const [showOauthMessageForEmployeeUserDialog, setShowOauthMessageForEmployeeUserDialog] = useState(false);
  const [genericDialogHeading, setGenericDialogHeading] = useState("");
  const [genericDialogText, setGenericDialogText] = useState("");
  
  const [errorMessage, setErrorMessage] = useState("");
  const requiredFieldError = "The fields highlighted in red are required.";
  const [productNumberError, setProductNumberError] = useState("");
  const [disableGoButtons, setDisableGoButtons] = useState(false);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [showSearchLoading, setShowSearchLoading] = useState(false);
  const [showAvailabilityCheck, setShowAvailabilityCheck] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [accountDetails, setAccountDetails] = useState(undefined);
  const [addressListResponse, setAddressListResponse] = useState(undefined);
  const [showData, setShowData] = useState(false);
  const [currentSelectedValue, setCurrentSelectedValue] = useState(false);

  // for accumulating account details across batches
  const approvedAccountDetailsRef = useRef(null);

  // ----- Refs for inputs (converted from this.accountNumberInput, etc.) -----
  const accountNumberInput = useRef(null);
  const zipCodeInput = useRef(null);
  const productNumberInput = useRef(null);
  const productLineSelect = useRef(null);
  
  useEffect(() => {
  if (accountNumberInput.current) accountNumberInput.current.value = "";
  if (zipCodeInput.current) zipCodeInput.current.value = "";
  if (productNumberInput.current) productNumberInput.current.value = "";
  if (productLineSelect.current) productLineSelect.current.value = "";
  props.saveAccountNumber("");
  props.saveZipCode("");
  props.saveAccountNumberDetails(null);
  props.saveZipCodeDetail(null);
}, []);

  // ----- Derived flags -----
  const isDisabledTextBox = useMemo(() => {
	const { product } = props.state;
	return !(
	  product.accountDetail &&
	  product.accountDetail.status &&
	  product.zipCodeDetail &&
	  product.zipCodeDetail.status
	);
  }, [props.state]);

  // ----- Effects (componentDidMount) -----
  useEffect(() => {
	window.scrollTo(0, 0);

	// reset redux slices (exactly as class version)
	props.saveProductLine("");
	props.savePostLoginSearchKeyword("");
	props.resetSearchKeywordSuggestionList();
	props.resetHomePageObjectInStore();
	props.saveSelectedAccountAndPriceSource({
	  selectedAccount: null,
	  selectedPriceSource: null,
	});

	setShowSuggestion(false);
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ----- Helpers ported from class -----
  const getLocalStorageVar = useCallback((variableName) => {
	const raw = localStorage.getItem(variableName);
	return raw ? JSON.parse(raw) : null;
  }, []);

  const updateAccountListToLocalStorage = useCallback(
	(accountList) => {
	  let obj = getLocalStorageVar(localStorageVar);
	  obj = { ...(obj || {}), accountList };
	  localStorage.setItem(localStorageVar, JSON.stringify(obj));
	},
	[getLocalStorageVar]
  );

  const removeLocalStorageVar = useCallback((name) => {
	localStorage.removeItem(name);
  }, []);

  const backToLoginPage = useCallback((e) => {
	e.preventDefault();
	browserHistory.push("/login");
  }, []);

  // numeric-only keypress
  const acceptsOnlyNumbers = useCallback((event) => {
	if (!(event.charCode >= 48 && event.charCode <= 57)) event.preventDefault();
  }, []);

  // validateFields: returns true when error occurred (kept semantics)
  const validateFields = useCallback((fields) => {
	let errorOccured = false;
	for (let i = 0; i < fields.length; i++) {
	  const fld = fields[i].field;
	  const origClassName = fld.className;
	  fld.className = fld.value === "" ? "error" : "";

	  if (fields[i].minLength && fld.value !== "") {
		fld.className = fld.value.length !== fields[i].minLength ? "error" : "";
	  }
	  if (origClassName.indexOf("invalid") !== -1) {
		fld.className = "invalid error";
		errorOccured = true;
	  }
	  if (errorOccured === false && fld.value === "") {
		errorOccured = true;
		fld.focus();
	  }
	}
	return errorOccured;
  }, []);

  // ----- Dialog handling -----
  const handleDialog = useCallback((dialog, flag, event) => {
	event && event.preventDefault();
	if (dialog === "AccountNotSetupProperlyOverlayDialog") {
	  setShowAccountNotSetupProperlyOverlayDialog(false);
	  setTimeout(() => setShowAccountNotSetupProperlyOverlayDialog(!!flag), 0);
	} else if (dialog === "OauthMessageForEmployeeUserDialog") {
	  setShowOauthMessageForEmployeeUserDialog(false);
	  setTimeout(() => setShowOauthMessageForEmployeeUserDialog(!!flag), 0);
	}
  }, []);

  const handleAccountNotSetupProperlyOverlayDialog = useCallback(
	(dialog, flag, event) => {
	  event && event.preventDefault();
	  removeLocalStorageVar(localStorageVar);
	  removeLocalStorageVar(redirectURLCNetVar);
	  handleDialog(dialog, flag, event);
	},
	[handleDialog, removeLocalStorageVar]
  );

  // ----- Field change / blur handlers -----
  const handleChange = useCallback(
	(event) => {
	  event.target.className = event.target.value === "" ? "error" : "";
	  if (event.target.name === "accountNumber") {
		if (event.target.value.length < 7){
			props.resetProductAvailabilityResultList();
			setShowData(false);
		}
		props.saveAccountNumberDetails(null);
	  } else if (event.target.name === "zipCode") {
		if (event.target.value.length != 5){
			props.resetProductAvailabilityResultList();
			setShowData(false);
		}
		props.saveZipCodeDetail(null);
	  }
	},
	[props]
  );

  const handleBlurEvent = useCallback(
	(event) => {
	  if (event.target.value === "") return;

	  // Account #
	  if (event.target.name === "accountNumber") {
		if (event.target.value.length < 7) {
		  event.target.className = "error";
		} else {
		  props.showAccountDetailProgress(true);
		  props.getAccountDetails(
			`accountNumber=${event.target.value}&requestType=getAccountDetails`,
			false,
			(response) => {
			  if (response.status && response.responseObject && response.responseObject.length > 0) {
				props.showAccountDetailProgress(false);
				props.saveAccountDetail(response);
				setAccountDetails(response.responseObject);
				// fetch address list
				props.getAddressList(
				  `accountNumber=${response.responseObject[0].ACCOUNTNUMBER}&partyId=${response.responseObject[0].PARTYID}&requestType=getAddressList`,
				  false,
				  (resp) => {
					if (resp.status) setAddressListResponse(resp.responseObject);
				  }
				);
			  }
			}
		  );
		}
		props.saveAccountNumber(event.target.value);
	  }

	  // Zip
	  else if (event.target.name === "zipCode") {
		if (event.target.value.length !== 5) {
		  event.target.className = "error";
		} else {
		  // Guard: addressListResponse may be undefined if account fetch not done yet
		  const country = addressListResponse && addressListResponse[0] && addressListResponse[0].COUNTRY ?  addressListResponse[0].COUNTRY : "US";
		  props.saveZipCodeDetail(null);
		  props.showZipCodeLoading(true);
		  const zip = event.target.value;
		  const acct = accountNumberInput.current ? accountNumberInput.current.value : "";

		  props.getShippingAddresses(
			`zip=${zip}&accountNumber=${acct}&country=${country}`,
			false,
			(resp) => {
			  props.showZipCodeLoading(false);
			  props.saveZipCodeDetail(resp);
			  if (resp.responseObject) {
				props.saveShippingAddresses({
				  zipCode: zip,
				  details: resp.responseObject,
				});
			  }
			},
			true
		  );
		}
		props.saveZipCode(event.target.value);
	  }
	},
	[addressListResponse, props]
  );

  // Product number input + suggestions
  const handleChangeProductNumber = useCallback(
	(event) => {
	  setShowSearchLoading(false);
	  setShowSuggestion(false);
	  setShowData(false);
	  productLineSelect.current.value = ""

	  const value = event.target.value;
	  const lastChar = value.substring(value.length - 1);
	  let lastKeyword = value.split(" ");
	  if (lastChar === " ") lastKeyword.pop();
	  lastKeyword = lastKeyword[lastKeyword.length - 1];

	  props.savePostLoginSearchKeyword(value);

	  if (lastChar === " " || lastKeyword.length <= 2) {
		props.resetSearchKeywordSuggestionList();
	  } else if (lastKeyword !== "" && lastKeyword.length > 2) {
		setShowSearchLoading(true);
		setShowSuggestion(true);
		props.saveSearchKeywordSuggestionList(null);
		props.getSearchKeywordSuggestionList(
		  `requestType=getItems&keyword=${lastKeyword}&count=5`,
		  (response) => {
			props.saveSearchKeywordSuggestionList(response.responseObject);
			setShowSearchLoading(false);
		  }
		);
	  }
	},
	[props]
  );

  const handleChangeProductLine = useCallback(
	(event) => {
	  props.saveProductLine({
		navigationState: event.target.value,
		label: event.target.options[event.target.selectedIndex].innerHTML,
	  });
	  setShowData(false);
	  productNumberInput.current.value = ""
	},
	[props]
  );

  const handleAutoSuggests = useCallback((flag) => {
	setTimeout(() => setShowSuggestion(!!flag), 200);
  }, []);

  const handleClickOfSuggest = useCallback(
	(e) => {
	  e.preventDefault();
	  const input = productNumberInput.current;
	  if (!input) return;
	  const value = input.value;
	  const selected = e.target.text;

	  if (value.indexOf(" ") === -1) {
		input.value = selected;
	  } else {
		const parts = value.split(" ");
		if (parts[parts.length - 1] === "") parts.pop();
		parts[parts.length - 1] = selected;
		input.value = parts.join(" ");
	  }
	  props.savePostLoginSearchKeyword(input.value);
	  props.showHideAutoSelect(false);
	},
	[props]
  );

  const validateSearchKeyword = useCallback((event) => {
	const value = event.target.value;
	const lastCharacter = value.substring(value.length - 1);
	const parts = value.split(" ");
	const noOfSpace = parts.length;

	setProductNumberError("");
	let lastKeyword = parts[parts.length - 1];

	// prevent invalid spaces / too many terms / too-short terms
	if (
	  (value === "" && event.charCode === 32) ||
	  (lastCharacter === " " && lastKeyword !== "") ||
	  (lastKeyword.length < 3 && event.charCode === 32) ||
	  (noOfSpace === 5 && event.charCode === 32) ||
	  noOfSpace === 6
	) {
	  event.preventDefault();
	}

	let errorMsg = "";
	if ((noOfSpace === 5 && event.charCode === 32) || noOfSpace === 6) {
	  errorMsg = "You can only enter 5 keywords separated by space.";
	}
	if (lastCharacter === " " && lastKeyword !== "") {
	  errorMsg = "There should be only one space between each keyword.";
	}
	if (value === "" && event.charCode === 32) {
	  errorMsg = "Keyword can not be start with space character.";
	}
	if (lastKeyword.length < 3 && event.charCode === 32) {
	  errorMsg = "Please enter valid minimum 3 characters in each keyword.";
	}
	setProductNumberError(errorMsg);
  }, []);

  // ----- Submit handlers -----
  const handleProductNumberSubmit = useCallback(
	(event) => {
	  event.preventDefault();
	  const acctEl = accountNumberInput.current;
	  const zipEl = zipCodeInput.current;
	  const pnEl = productNumberInput.current;
	  productLineSelect.current.value = ""

	  setErrorMessage(
		pnEl.value === "" || acctEl.value === "" || zipEl.value === "" ? requiredFieldError : ""
	  );

	  if (
		!validateFields([
		  { field: acctEl },
		  { field: zipEl, minLength: 5 },
		  { field: pnEl },
		])
	  ) {
		const { product } = props.state;
		if (!(product.zipCodeDetail && product.zipCodeDetail.status && product.accountDetail && product.accountDetail.status)) {
		  setErrorMessage("Please wait while fields are being validated.");
		} else {
		  setErrorMessage("");
		  props.saveAccountNumber(acctEl.value);
		  props.saveZipCode(zipEl.value);

		  setErrorMessage("");
		  // setDisableGoButtons(true); // intentionally commented like original

		  props.resetProductAvailabilityResultList();
		  props.checkAndSetSearchResult(
			"product-number",
			acctEl.value,
			zipEl.value,
			pnEl.value,
			"",
			() => {
			  setErrorMessage("");
			  setDisableGoButtons(false);
			  setSearchType("product-number");
			  setCurrentSelectedValue(pnEl.value);
			  setShowAvailabilityCheck(true);
			  setShowData(true);
			},
			false
		  );
		}
	  }
	},
	[props, requiredFieldError, validateFields]
  );

  const handleProductLineSubmit = useCallback(
	(event) => {
	  event.preventDefault();
	  const acctEl = accountNumberInput.current;
	  const zipEl = zipCodeInput.current;
	  const lineEl = productLineSelect.current;
	  productNumberInput.current.value = ""

	  setErrorMessage(
		lineEl.value === "" || acctEl.value === "" || zipEl.value === "" ? requiredFieldError : ""
	  );

	  if (
		!validateFields([
		  { field: acctEl },
		  { field: zipEl, minLength: 5 },
		  { field: lineEl },
		])
	  ) {
		const { product } = props.state;
		if (!(product.zipCodeDetail && product.zipCodeDetail.status === true && product.accountDetail && product.accountDetail.status === true)) {
		  setErrorMessage("Please wait fields are being validated.");
		} else {
		  setErrorMessage("");
		  props.saveAccountNumber(acctEl.value);
		  props.saveZipCode(zipEl.value);

		  // Clear filters + lists
		  props.saveProductLineFilters(null);
		  props.resetProductNumberKeywordResultList();

		  setErrorMessage("");
		  // setDisableGoButtons(true); // intentionally commented

		  props.resetProductAvailabilityResultList();
		  props.checkAndSetSearchResult(
			"product-line",
			acctEl.value,
			zipEl.value,
			"",
			lineEl.value,
			() => {
			  setErrorMessage("");
			  setSearchType("product-line");
			  setDisableGoButtons(false);
			  setCurrentSelectedValue(lineEl.value);
			  setShowAvailabilityCheck(true);
			  setShowData(true);
			},
			false
		  );

		  // parallel narrow filters fetch
		  props.saveProductLineNarrowYourResultsFilters(null);
		  const categoryId = lineEl.value.replace("?N=", "");
		  props.getProductLineNarrorYourResultFilters(`requestType=getProductLine&categoryId=${categoryId}`);
		}
	  }
	},
	[props, requiredFieldError, validateFields]
  );

  // ----- Batched account details (non-GEA SSO helper parity; kept though not used here directly) -----
  const getAccountDetailsBatch = useCallback((accountNumbers, sso, callback) => {
	const requests = accountNumbers.map((accountNumber) =>
	  sendRequest(
		bootAPIUrl,
		users.account.path,
		"",
		users.account.method,
		`accountNumber=${accountNumber}&requestType=getAccountDetails&ssoId=${sso}`
	  )
	);

	if (requests.length) {
	  Promise.all(requests).then((responses) => {
		approvedAccountDetailsRef.current =
		  approvedAccountDetailsRef.current || { responseObject: [] };

		responses.forEach((res) => {
		  if (res.responseObject && res.responseObject.length) {
			approvedAccountDetailsRef.current.responseObject.push(res.responseObject[0]);
		  }
		});

		callback && callback();
	  });
	}
  }, []);

  const updateAccountDetailsInBatches = useCallback(
	(batches, sso) => {
	  if (batches.length) {
		const accountNumbers = batches.shift();
		getAccountDetailsBatch(accountNumbers, sso, () => {
		  updateAccountDetailsInBatches(batches, sso);
		});
	  } else {
		props.ajaxRequestCompleted();
		props.saveApprovedAccountDetails(approvedAccountDetailsRef.current);
		updateAccountListToLocalStorage(approvedAccountDetailsRef.current);
		// fetchHomePageAssets() isn’t present here; kept parity with original’s call site
		approvedAccountDetailsRef.current = null;
	  }
	},
	[getAccountDetailsBatch, props, updateAccountListToLocalStorage]
  );

  // ----- Render -----
  const { state } = props;
  const invalidAccountMsg =
	state.product.accountDetail &&
	state.product.accountDetail.responseObject &&
	(!state.product.accountDetail.status ||
	  state.product.accountDetail.responseObject.length === 0 ||
	  state.product.accountDetail.responseObject[0].STATUS !== "A");

  const invalidZipMsg = state.product.zipCodeDetail && !state.product.zipCodeDetail.status;

  const postLoginKW =
  (props.state.searchKeyword && props.state.searchKeyword.postLoginSearchKeyword) || "";

  const acctReady =
  accountNumberInput.current &&
  accountNumberInput.current.value &&
  accountNumberInput.current.value.trim().length >= 7;

const zipReady =
  zipCodeInput.current &&
  zipCodeInput.current.value &&
  zipCodeInput.current.value.trim().length === 5;

const disableByInput = !(acctReady && zipReady);

  return (
	<div>
	  <div className="geStoreHomePageLayoutRightSideResponsive">
		<div className="prelaunchSearch">
		  <h3 className="mt-0" style={{ lineHeight: 1.5 }}>
			For Parts Availability, please go back to the{" "}
			<a className="ms-1" href="" onClick={backToLoginPage}>
			  prior page
			</a>{" "}
			and login
			<br />
			For all other Product Availability:
		  </h3>

		  <p className="red">
			<strong>{errorMessage}</strong>
		  </p>

		  {invalidAccountMsg ? (
			<p className="red">
			  <strong>
				You have entered an invalid Account Number. Try re-entering the information below.
			  </strong>
			</p>
		  ) : null}

		  {invalidZipMsg ? (
			<p className="red">
			  <strong>You have entered an invalid Zip Code. Try re-entering the information below.</strong>
			</p>
		  ) : null}

		  <div className="row">
			<div className="columns large-6 medium-6 small-6">
			  <div className="row">
				<div className="columns large-8 medium-7 small-12">
				  <label htmlFor="loginAccountNumber">
					<b>
					  <span className="hide-for-small inline">Enter</span> Account #
					</b>
				  </label>
				</div>
				<div className="columns large-4 medium-5 small-12">
				  <input
					type="text"
					defaultValue={state.product.accountNumber}
					className={
					  state.product.accountDetail &&
					  (!state.product.accountDetail.status ||
						state.product.accountDetail.responseObject.length === 0)
						? "invalid error"
						: ""
					}
					name="accountNumber"
					onKeyPress={acceptsOnlyNumbers} // fixed wiring
					ref={accountNumberInput}
					onBlur={handleBlurEvent}
					onChange={handleChange}
					onPaste={(e) => manipulateClipBoardToKeepNumericsOnly(handleChange, e)}
					id="loginAccountNumber"
					style={{ width: 100 }}
				  />
				</div>
			  </div>
			  <div
				className={
				  "loader account-number-loader " +
				  (state.product.accountDetailProgress ? "" : "hide")
				}
			  >
				&#160;
			  </div>
			</div>

			<div className="columns large-6 medium-6 small-6">
			  <div className="row">
				<div className="columns large-8 medium-7 small-12">
				  <label htmlFor="loginZipCode">
					<b>Zip Code</b>
				  </label>
				</div>
				<div className="columns large-4 medium-5 small-12">
				  <input
					type="text"
					defaultValue={state.product.zipCode}
					className={
					  state.product.zipCodeDetail && !state.product.zipCodeDetail.status
						? "invalid error"
						: ""
					}
					name="zipCode"
					onKeyPress={acceptsOnlyNumbers}
					ref={zipCodeInput}
					onBlur={handleBlurEvent}
					onChange={handleChange}
					maxLength={5}
					id="loginZipCode"
					style={{ width: 100 }}
				  />
				</div>
			  </div>
			  <div className={"loader zip-code-loader " + (state.product.zipCodeProgress ? "" : "hide")}>
				&#160;
			  </div>
			</div>
		  </div>

		  <h4 className="thEmulator">By Product Number</h4>
		  <p>For multiple products, enter a space between product numbers.</p>

		  <div className="product-number-error-msg">
			<p className="red">
			  <strong>{productNumberError}</strong>
			</p>
		  </div>

		  <div className="product-number-container">
			<form onSubmit={handleProductNumberSubmit}>
			  <input
				type="text"
				id="outsideProdSearchName"
				name="outsideProdSearchName"
				ref={productNumberInput}
				onChange={handleChangeProductNumber}
				onKeyPress={validateSearchKeyword}
				onBlur={() => handleAutoSuggests(false)}
				onFocus={() => handleAutoSuggests(true)}
				className="outsideProdSearchName"
				disabled={isDisabledTextBox}
				autoComplete="off"
			  />
			  &#160;
			  <input type="submit" 
			  	disabled={isDisabledTextBox || disableByInput }
			   className="blueButton" value="GO" />

			  <div
					id="product-number-autocomplete"
					className={showSuggestion && postLoginKW.trim() !== "" ? "show" : "hide"}
					>
				{showSearchLoading ? (
				  <div>
					<br />
					<div className="loader">&#160;</div>
					<br />
				  </div>
				) : null}

				{!showSearchLoading &&
				props.state.searchKeyword.productNumberList &&
				props.state.searchKeyword.productNumberList.length === 0 ? (
				  <div>
					<br />
					<strong>No Results found.</strong>
					<br />
					<br />
				  </div>
				) : null}

				{!showSearchLoading &&
				  props.state.searchKeyword.productNumberList &&
				  props.state.searchKeyword.productNumberList.length > 0 &&
				  props.state.searchKeyword.productNumberList.map((item, index) => (
					<a key={index} onClick={handleClickOfSuggest} href="">
					  {item.sku}
					</a>
				  ))}
			  </div>
			</form>
		  </div>

		  <p />

		  <form onSubmit={handleProductLineSubmit}>
			<select
			  id="outsideProdSearchLine"
			  name="outsideProdSearchLine"
			  ref={productLineSelect}
			  onChange={handleChangeProductLine}
			  className="outsideProdSearchLine"
			>
			  <option value="">Select Product Line</option>
			  {productLineList.map((item, index) => {
				if (item.hideInPrelogin || item.type === "filter") return null;
				return (
				  <option key={index} value={`?N=${item.categoryId}`}>
					{item.name}
				  </option>
				);
			  })}
			</select>{" "}
			<input type="submit" 
			disabled={isDisabledTextBox || disableByInput }
			className="blueButton" value="GO" />
		  </form>
		</div>
	  </div>

	  {showAccountNotSetupProperlyOverlayDialog ? (
		<GenericOverlayDialog
		  genericDialogHeading={genericDialogHeading}
		  genericDialogText={genericDialogText}
		  buttons="ok"
		  flag="AccountNotSetupProperlyOverlayDialog"
		  handleDialog={handleAccountNotSetupProperlyOverlayDialog}
		  showDialog={true}
		/>
	  ) : null}

	  {showAvailabilityCheck && showData  ? (
		<PreLoginSearchResult 
		 key={`availability-${currentSelectedValue}`} 
		pageName="availabilityCheck" {...props} searchType={searchType} />
	  ) : null}
	</div>
  );
}

/* Redux wiring preserved */
const mapStateToProps = (state) => ({ state });

const mapDispatchToProps = (dispatch) => ({
  saveZipCodeDetail: (data) => dispatch(saveZipCodeDetail(data)),
  saveZipCode: (data) => dispatch(saveZipCode(data)),
  saveAccountNumber: (data) => dispatch(saveAccountNumber(data)),
  saveAccountNumberDetails: (data) => dispatch(saveAccountNumberDetails(data)),
  getAddressList: (q, s, cb) => dispatch(getAddressList(q, s, cb)),
  getShippingAddresses: (q, s, cb, save) => dispatch(getShippingAddresses(q, s, cb, save)),
  saveProductLine: (data) => dispatch(saveProductLine(data)),
  savePostLoginSearchKeyword: (data) => dispatch(savePostLoginSearchKeyword(data)),
  resetSearchKeywordSuggestionList: () => dispatch(resetSearchKeywordSuggestionList()),
  resetHomePageObjectInStore: () => dispatch(resetHomePageObjectInStore()),
  resetProductNumberKeywordResultList: () => dispatch(resetProductNumberKeywordResultList()),
  saveSelectedAccountAndPriceSource: (data) => dispatch(saveSelectedAccountAndPriceSource(data)),
  saveAccountNumberPostLogin: (data) => dispatch(saveAccountNumberPostLogin(data)),
  showHideAutoSelect: (data) => dispatch(showHideAutoSelect(data)),
  saveSearchKeywordSuggestionList: (data) => dispatch(saveSearchKeywordSuggestionList(data)),
  saveProductLineFilters: (data) => dispatch(saveProductLineFilters(data)),
  getSearchKeywordSuggestionList: (p, cb) => dispatch(getSearchKeywordSuggestionList(p, cb)),
  getAccountDetails: (q, s, cb) => dispatch(getAccountDetails(q, s, cb)),
  saveAccountDetail: (d) => dispatch(saveAccountDetail(d)),
  checkCredentials: (p, cb) => dispatch(checkCredentials(p, cb)),
  getAuthDetails: (q, cb) => dispatch(getAuthDetails(q, cb)),
  deleteAuthDetails: (q) => dispatch(deleteAuthDetails(q)),
  saveUserDetails: (d) => dispatch(saveUserDetails(d)),
  resetUserDetails: () => dispatch(resetUserDetails()),
  getPunchOutData: (q, cb) => dispatch(getPunchOutData(q, cb)),
  postPunchOutData: (d, u, cb) => dispatch(postPunchOutData(d, u, cb)),
  getUserDetails: (q, cb) => dispatch(getUserDetails(q, cb)),
  getLocalUserDetails: (q, s, cb) => dispatch(getLocalUserDetails(q, s, cb)),
  getApprovedAccounts: (q, cb) => dispatch(getApprovedAccounts(q, cb)),
  saveApprovedAccountDetails: (d) => dispatch(saveApprovedAccountDetails(d)),
  saveSSORegistrationDetails: (d) => dispatch(saveSSORegistrationDetails(d)),
  saveUserOtherDetails: (d) => dispatch(saveUserOtherDetails(d)),
  getAssets: (s, cb) => dispatch(getAssets(s, cb)),
  populateLatestHomePageAssets: () => dispatch(populateLatestHomePageAssets()),
  saveProductLineNarrowYourResultsFilters: (d) => dispatch(saveProductLineNarrowYourResultsFilters(d)),
  showAccountDetailProgress: (d) => dispatch(showAccountDetailProgress(d)),
  showZipCodeLoading: (d) => dispatch(showZipCodeLoading(d)),
  getProductLineNarrorYourResultFilters: (p) => dispatch(getProductLineNarrorYourResultFilters(p)),
  updateHomePageAssetsFromBackup: (d) => dispatch(updateHomePageAssetsFromBackup(d)),
  saveInvalidAttempt: (d) => dispatch(saveInvalidAttempt(d)),
  saveShippingAddresses: (d) => dispatch(saveShippingAddresses(d)),
  resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
  updateInvalidAttempt: (p, cb) => dispatch(updateInvalidAttempt(p, cb)),
  getRegistrationHelpDoc: (q, cb) => dispatch(getRegistrationHelpDoc(q, cb)),
  getNonGEASSOUserAccounts: (q, cb) => dispatch(getNonGEASSOUserAccounts(q, cb)),
  ajaxRequestInitiated: (d) => dispatch(ajaxRequestInitiated(d)),
  ajaxRequestCompleted: (d) => dispatch(ajaxRequestCompleted(d)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityCheck);


// WEBPACK FOOTER //
// ./src/App/components/PreLogin/AvailabilityCheck/index.js